<template>
  <div>
    <b-row>
      <b-col
        sm="12"
        md="8">
        <j-title-header
          v-show="false"
          :options="titleBasicInfo"/>
        <b-row>
          <b-col
            sm="12"
            md="6">
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <label>User Company ID</label>
                  <j-input
                    v-model="user_company_id"
                    :disabled="true"
                    placeholder="ID"/>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label>User ID</label>
                  <j-input
                    v-model="data_employee.id"
                    :disabled="true"
                    placeholder="ID"/>
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group :class="{'error-input' : $v.data_employee.first_name.$error}">
              <label> First Name* </label>
              <j-input
                v-model="$v.data_employee.first_name.$model"
                :max-length="50"
                placeholder="First Name"/>
            </b-form-group>
            <b-form-group>
              <label> Place Of Birth </label>
              <j-input
                v-model="data_employee.place_of_birth"
                :max-length="50"
                placeholder="Place Of Birth"/>
            </b-form-group>
            <b-form-group :class="{'error-input' : $v.data_employee.phone_number.$error}">
              <label> Phone Number* </label>
              <j-input
                v-model="$v.data_employee.phone_number.$model"
                :max-length="50"
                placeholder="Phone Number"
                type="number"/>
            </b-form-group>
            <b-row>
              <b-col
                md="10"
                class="p__r--1">
                <label> Active </label>
                <div class="label-info-user-active">
                  An active user can access Officeless App & Studio.
                </div>
                <router-link
                  to="/administrator/company/settings/security"
                  class="label-more-info-user-active">
                  More Info
                </router-link>
              </b-col>
              <b-col
                md="2"
                class="p__l--1">
                <j-toggle
                  v-model="data_employee.employee_status"
                  :disabled="isAdmin" />
              </b-col>
            </b-row>
          </b-col>

          <b-col
            sm="12"
            md="6">
            <b-form-group>
              <label>Email</label>
              <j-input
                v-model="data_employee.email"
                :max-length="50"
                placeholder="Personal Email"
                disabled/>
            </b-form-group>
            <b-form-group>
              <label> Last Name </label>
              <j-input
                v-model="data_employee.last_name"
                :max-length="50"
                placeholder="Last Name"/>
            </b-form-group>
            <b-row>
              <b-col
                sm="12"
                md="8">
                <b-form-group :class="{'error-input' : $v.data_employee.date_of_birth.$error}">
                  <label> Date Of Birth* </label>
                  <j-datepicker
                    v-model="data_employee.date_of_birth"
                    :disabled-dates="birthday_dates"
                    :error-required="$v.data_employee.date_of_birth.$error"
                    format="MMM dd, yyyy"
                    error-message="Age must be greater or equal to 18"
                    placeholder="Jan 01, 2020"/>
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
                md="4">
                <b-form-group>
                  <label> Age </label>
                  <j-input
                    v-model="data_employee.age"
                    error-message="err"
                    disabled/>
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group
              v-show="load_first"
              :class="{'error-input' : $v.data_employee.role.$error}">
              <label> Role* </label>
              <j-single-select
                v-model="data_employee.role"
                :options="roles_option"
                :disabled="isAdmin"
                value-format="object"
                placeholder="Select Role"
                label="name"/>
            </b-form-group>

            <b-form-group
              v-show="false"
              :class="{'error-input' : $v.data_employee.password.$error}">
              <label> New Password </label>
              <j-input
                v-model="data_employee.password"
                :max-length="50"
                placeholder="Password"
                error-message="Password minimum is 5 character"/>
              <j-checkbox
                v-model="show_pass"
                class="float-to-right">show password</j-checkbox>
            </b-form-group>
            <b-form-group v-show="false">
              <label> Employee Code </label>
              <j-input
                v-model="data_employee.code"
                :max-length="50"
                placeholder="Employee Code"/>
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="4"/>
        </b-row>

        <j-title-header
          v-show="false"
          :options="titleAccountProfile"/>
        <b-row v-show="false">
          <b-col
            sm="12"
            md="6">
            <b-form-group>
              <label>ID Type</label>
              <j-single-select
                v-model="data_employee.id_type"
                :options="id_type_options"
                label="name"
                value-format="object"
                placeholder="Select ID Type"/>
            </b-form-group>
            <b-form-group>
              <label>Religion</label>
              <j-single-select
                v-model="data_employee.religion"
                :options="religion_options"
                label="name"
                placeholder="Select Religion"/>
            </b-form-group>
            <b-form-group>
              <label>Nationality</label>
              <j-single-select
                v-model="data_employee.nationality_type"
                :options="nationality_options"
                label="name"
                placeholder="Select Nationality"/>
            </b-form-group>
            <b-form-group>
              <label>Home Address</label>
              <j-textarea
                v-model="data_employee.address"
                placeholder="Home Address"/>
            </b-form-group>
          </b-col>

          <b-col
            sm="12"
            md="6">
            <b-form-group v-show="false">
              <label>Marital Status</label>
              <j-single-select
                v-model="data_employee.marital_status"
                :options="marital_options"
                label="name"
                placeholder="Select Marital Status"/>
            </b-form-group>
            <b-form-group>
              <label>Postal Code</label>
              <j-input
                v-model="data_employee.postal_code"
                placeholder="Postal Code"/>
            </b-form-group>
            <b-form-group>
              <label>Country of Home Address</label>
              <j-single-select
                v-model="data_employee.country"
                :options="list_country"
                placeholder="Select Country"
                value-format="object"
                label="name"
                @select="resetProvince"/>
            </b-form-group>
            <b-form-group v-show="data_employee.country && data_employee.country.id">
              <label>Province of Home Address</label>
              <j-single-select
                v-model="data_employee.province"
                :options="home_province_options"
                placeholder="Select Province"
                label="name"
                @select="resetCity"/>
            </b-form-group>
            <b-form-group v-show="data_employee.province">
              <label>City of Home Address</label>
              <j-single-select
                v-model="data_employee.city"
                :options="home_city_options"
                placeholder="Select City"
                label="name"/>
            </b-form-group>
          </b-col>

          <b-col
            sm="12"
            md="12">
            <b-form-group>
              <label>Notes</label>
              <j-textarea
                v-model="data_employee.notes"
                placeholder="Employee Notes"/>
            </b-form-group>
          </b-col>
        </b-row>

        <j-title-header
          v-show="false"
          :options="titleSettings"/>
        <b-row v-show="false">
          <b-col
            sm="12"
            md="12">
            <b-form-group>
              <label> Secretary Mode </label>
              <j-toggle
                v-model="data_employee.secretary_mode"/>
            </b-form-group>
            <b-form-group>
              <label> Secretary Mode Mapping Team </label>
              <j-multi-select
                v-model="data_employee.secretary_mode_mapping"
                :options="list_teams"
                label="name"
                value-format="object"
                placeholder="Select Secretary Mode Mapping Team"/>
            </b-form-group>
            <b-form-group>
              <label> Employee ID </label>
              <j-input
                v-model="data_employee.employee_id"
                :max-length="50"
                placeholder="Employee ID"/>
            </b-form-group>
          </b-col>
        </b-row>

        <j-title-header
          v-show="false"
          :options="titlePaymentInfo"/>
        <b-row v-show="false">
          <b-col
            sm="12"
            md="12">
            <b-form-group>
              <label> Bank Name </label>
              <j-single-select
                v-model="data_employee.bank_name"
                :options="list_bank"
                placeholder="Select Bank Name"
                value-format="object"
                label="name"/>
            </b-form-group>
            <b-form-group>
              <label> Bank Account Number </label>
              <j-input
                v-model="data_employee.bank_account_number"
                :max-length="50"
                placeholder="Bank Account Number"/>
            </b-form-group>
            <b-form-group>
              <label> Bank Account Holder Name </label>
              <j-input
                v-model="data_employee.bank_account_holder_name"
                :max-length="50"
                placeholder="Bank Account Name"/>
            </b-form-group>
            <b-form-group>
              <label> Bank Account Branch </label>
              <j-input
                v-model="data_employee.bank_account_branch"
                :max-length="50"
                placeholder="Bank Account Name"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>

      <b-col
        sm="12"
        md="3">
        <b-form-group>
          <label> Photo Profile </label>
          <j-photo-uploader
            ref="multi"
            :api-token="api"
            :img-default="image_default"
            :url-upload="url_upload"
            :label="!image_default ? 'Upload Photo' : 'Change Photo'"
            @url="getDataImage" />
        </b-form-group>
      </b-col>

    </b-row>

  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable max-len */
/* eslint-disable no-unneeded-ternary */
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { required, minLength, minValue } from 'vuelidate/lib/validators';
import { mapState, mapActions, mapMutations } from 'vuex';
import Constant from '@/utils/constant';
import jPhotoUploader from '@/components/upload-foto/jPhotoUploader';

export default {
  components: {
    jPhotoUploader,
  },
  validations() {
    const validation = {
      data_employee: {
        email: {
          required,
        },
        password: {
          minLength: minLength(5),
        },
        first_name: {
          required,
        },
        end_date: {
          // do nothing
        },
        date_of_birth: {
          required,
        },
        age: {
          // do nothing
        },
        phone_number: {
          required,
        },
        role: {
          required,
        },
      },
      data_position: {
        position: {

        },
      },
    };
    if (this.data_employee.employment_type === 'CONTRACT') {
      validation.data_employee.contract_type = { };
      validation.data_employee.contract_end_date = { };
    }
    if (!this.data_employee.employee_status) {
      validation.data_employee.nonactive_reason = { };
    } else if (this.data_employee.employee_status) {
      validation.data_employee.active_reason = { };
    }
    if (this.data_employee.date_of_birth) {
      if (this.data_employee.age < 18) {
        validation.data_employee.age = { minValue: minValue(18) };
      }
    }
    return validation;
  },
  data() {
    return {
      jConstant: Constant,
      load_first: false,
      show_office_city: false,
      titleBasicInfo: {
        icon: 'fa-user',
        main_title: 'Identity',
        opt_title: '',
      },
      titleSettings: {
        icon: 'fa-user',
        main_title: 'Settings',
        opt_title: '',
      },
      titleEmploymentData: {
        icon: 'fa-user',
        main_title: 'Employment Data',
        opt_title: '',
      },
      titlePaymentInfo: {
        icon: 'fa-user',
        main_title: 'Payment Info',
        opt_title: '',
      },
      titleAccountProfile: {
        icon: 'fa-user',
        main_title: 'Account Profile',
        opt_title: '',
      },
      titlePosition: {
        icon: 'fa-user',
        main_title: 'Position',
        opt_title: '',
      },
      disabled_start_dates: {
        color: 'white',
        background_color: 'light-grey',
        ranges: [
          {
            from: new Date(1970, 0, 1),
            to: new Date(1970, 0, 1),
          },
        ],
      },
      disabled_end_dates: {
        color: 'white',
        background_color: 'light-grey',
        ranges: [
          {
            from: new Date(1970, 0, 1),
            to: new Date(1970, 0, 1),
          },
        ],
      },
      disabled_contract_start_date: {
        color: 'white',
        background_color: 'light-grey',
        ranges: [
          {
            from: new Date(1970, 0, 1),
            to: new Date(1970, 0, 1),
          },
        ],
      },
      disabled_contract_end_date: {
        color: 'white',
        background_color: 'light-grey',
        ranges: [
          {
            from: new Date(1970, 0, 1),
            to: new Date(1970, 0, 1),
          },
        ],
      },
      birthday_dates: {
        color: 'white',
        background_color: 'light-grey',
        ranges: [
          {
            from: new Date(),
            to: new Date(9999, 11, 31),
          },
        ],
      },
      data_employee: {
        id: 0,
        // basic info
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        other_name: '',
        personal_email: '',
        gender: null,
        nationality_type: null,
        id_type: null,
        exp_date: null,
        id_number: null,
        religion: null,
        marital_status: null,
        address: null,
        postal_code: null,
        // settings
        role: null,
        secretary_mode: false,
        secretary_mode_mapping: [],
        employee_id: '',
        // payment info
        bank_name: null,
        bank_account_number: '',
        bank_account_holder_name: '',
        bank_account_branch: '',
        // employment data
        join_date: null,
        employment_type: null,
        contract_type: null,
        contract_time_remaining: null,
        contract_start_date: null,
        contract_end_date: null,
        code: '',
        end_date: null,
        teams: null,
        employee_status: null,
        active_reason: null,
        nonactive_reason: null,
        office_country: null,
        office_province: null,
        office_city: null,
        company_location: null,
        // account profile
        photo: null,
        date_of_birth: '',
        age: '',
        place_of_birth: '',
        phone_number: '',
        country: null,
        province: null,
        city: null,
        notes: '',
      },
      data_position: {
        id: 0,
        position: null,
        parent_position: '',
        division: [],
      },
      data_positions: [],
      image_default: null,
      show_pass: false,
      user_company_id: 0,
      index_positions: 0,
      labelAddPosition: 'Add Position',
      labelBtnPosition: 'Submit',
      home_city_options: [],
      home_province_options: [],
      office_city_options: [],
      office_province_options: [],
      gender_options: [
        {
          name: 'Male',
          id: 'Male',
        },
        {
          name: 'Female',
          id: 'Female',
        },
      ],
      id_type_options: [
        {
          name: 'KTP / Identity Card',
          text: 'KTP',
          id: Constant.IdTypeKTP,
        },
        {
          name: 'Passport',
          text: 'PASSPORT',
          id: Constant.IdTypePassport,
        },
      ],
      religion_options: [
        {
          name: 'Islam',
          id: 'Islam',
        },
        {
          name: 'Protestant',
          id: 'Christian',
        },
        {
          name: 'Catholic',
          id: 'Catholic',
        },
        {
          name: 'Hindu',
          id: 'Hindu',
        },
        {
          name: 'Buddha',
          id: 'Buddha',
        },
        {
          name: 'Konghucu',
          id: 'Konghucu',
        },
        {
          name: 'Other',
          id: 'Other',
        },
      ],
      marital_options: [
        {
          name: 'Single',
          id: 'Single',
        },
        {
          name: 'Married',
          id: 'Married',
        },
        {
          name: 'Divorced',
          id: 'Divorced',
        },
        {
          name: 'Widowed',
          id: 'Widowed',
        },
      ],
      contract_type_option: [
        {
          id: 'PKWT 1',
          name: 'PKWT 1',
        },
        {
          id: 'PKWT 2',
          name: 'PKWT 2',
        },
      ],
      roles_option: [
        {
          id: Constant.RoleImplementor,
          name: 'Implementor',
        },
        {
          id: Constant.RoleUser,
          name: 'User',
        },
      ],
      employment_type_option: [
        {
          id: 'PERMANENT',
          name: 'Permanent',
        },
        {
          id: 'PROBATION',
          name: 'Probation',
        },
        {
          id: 'CONTRACT',
          name: 'Contract',
        },
        {
          id: 'OUTSOURCE',
          name: 'Outsource',
        },
        {
          id: 'INTERNSHIP',
          name: 'Internship',
        },
        {
          id: 'CONSULTANT',
          name: 'Consultant',
        },
        {
          id: 'OJT',
          name: 'OJT',
        },
        {
          id: 'PART TIME',
          name: 'Part Time',
        },
        {
          id: 'OTHERS',
          name: 'Others',
        },
      ],
      teams_option: [],
      status_option: [
        {
          id: 1,
          name: 'Active',
        },
        {
          id: 0,
          name: 'Nonactive',
        },
      ],
      active_reason_option: [
        {
          id: 'Paid Leave',
          name: 'Paid Leave',
        },
        {
          id: 'Unpaid Leave',
          name: 'Unpaid Leave',
        },
      ],
      nonactive_reason_option: [
        {
          id: 'Serving Notice Period',
          name: 'Serving Notice Period',
        },
        {
          id: 'Terminated',
          name: 'Terminated',
        },
        {
          id: 'Resigned',
          name: 'Resigned',
        },
        {
          id: 'Retrenched',
          name: 'Retrenched',
        },
        {
          id: 'Contract End',
          name: 'Contract End',
        },
        {
          id: 'To Join',
          name: 'To Join',
        },
      ],
      nationality_options: [
        {
          id: 'Warga Negara Indonesia (WNI)',
          name: 'Warga Negara Indonesia (WNI)',
        },
        {
          id: 'Warga Negara Asing (WNA)',
          name: 'Warga Negara Asing (WNA)',
        },
      ],
      isAdmin: null,
    };
  },
  computed: {
    ...mapState('jStoreEmployee', ['list_company', 'list_country', 'list_province', 'list_city', 'list_bank', 'list_teams', 'employee_detail', 'organigram_detail']),

    api() {
      return this.$ls.get('Token', null);
    },
    url_upload() {
      return `${process.env.GATE_URL}/file`;
    },
    password_id() {
      if (this.show_pass) {
        return 'text';
      }
      return 'password';
    },
  },
  watch: {
    employee_detail(newVal) {
      const dataMapSec = [];
      newVal.secretary_mode_list_team.forEach((val) => {
        dataMapSec.push({
          id: val,
        });
      });

      const dataBank = [];
      if (newVal.company.bank_account_name && this.list_bank.length > 0) {
        const listBank = this.list_bank.filter(fildat =>
          fildat.name.toLowerCase() === newVal.company.bank_account_name.toLowerCase());
        if (listBank.length > 0) {
          dataBank.push(listBank[0]);
        }
      }

      const dataRoleNames = [];
      newVal.role_names.forEach((val) => {
        dataRoleNames.push({
          id: val,
        });
      });

      const employeeForm = {
        id: newVal.id,
        email: newVal.email,
        first_name: newVal.first_name,
        last_name: newVal.last_name,
        personal_email: newVal.personal_email,
        join_date: newVal.company.join_date && newVal.company.join_date !== '0000-00-00' ? newVal.company.join_date : null,
        employment_type_id: newVal.company.employment_type_id ? newVal.company.employment_type_id : null,
        employment_subtype_id: newVal.company.employment_subtype_id ? newVal.company.employment_subtype_id : null,
        employment_type: newVal.company.contract_type ? newVal.company.contract_type : null,
        contract_type: newVal.company.type_of_contract ? newVal.company.type_of_contract : null,
        contract_time_remaining: newVal.company.contract_time_remaining ? newVal.company.contract_time_remaining : null,
        code: newVal.company.employee_code,
        end_date: newVal.company.resign_date && newVal.company.resign_date !== '0000-00-00' ? newVal.company.resign_date : null,
        teams: newVal.company.group_id !== 0 ? { id: newVal.company.group_id } : null,
        employee_status: newVal.company.employee_status === 1 ? true : false,
        active_reason: newVal.company.active_reason === 0 || newVal.company.active_reason === '' ? null : newVal.company.active_reason,
        nonactive_reason: newVal.company.non_active_reason === '' ? null : newVal.company.non_active_reason,
        role: newVal.user_role ? { id: newVal.user_role } : null,
        role_names: dataRoleNames,
        secretary_mode: newVal.secretary_mode_list_team.length > 0 ? true : false,
        secretary_mode_mapping: dataMapSec,
        bank_name: dataBank.length > 0 ? dataBank[0] : null,
        bank_account_number: newVal.company.bank_account_number,
        bank_account_holder_name: newVal.company.bank_account_owner,
        bank_account_branch: newVal.company.bank_account_branch,
        employee_id: newVal.employee_id,
        date_of_birth: newVal.date_of_birth,
        age: newVal.age,
        place_of_birth: newVal.place_of_birth,
        phone_number: newVal.phone_number,
        photo: newVal.photo_url,
        country: newVal.country_id ? { id: newVal.country_id } : null,
        other_name: newVal.other_name ? newVal.other_name : null,
        gender: newVal.gender ? newVal.gender : null,
        id_type: newVal.id_type ? { id: newVal.id_type } : null,
        id_number: newVal.id_number ? newVal.id_number : null,
        religion: newVal.religion ? newVal.religion : null,
        marital_status: newVal.marital_status ? newVal.marital_status : null,
        address: newVal.address ? newVal.address : null,
        postal_code: newVal.postal_code ? newVal.postal_code : null,
        province: newVal.province_id ? newVal.province_id : null,
        city: newVal.city_id ? newVal.city_id : null,
        office_city: newVal.company.office_city_id ? newVal.company.office_city_id : null,
        office_province: newVal.company.office_province_id ? newVal.company.office_province_id : null,
        office_country: newVal.company.office_country_id ? newVal.company.office_country_id : null,
        company_location: newVal.company.location_id ? newVal.company.location_id : null,
        contract_start_date: newVal.company.contract_start_date && newVal.company.contract_start_date !== '0000-00-00' ? newVal.company.contract_start_date : null,
        contract_end_date: newVal.company.contract_end_date && newVal.company.contract_end_date !== '0000-00-00' ? newVal.company.contract_end_date : null,
        office_address: newVal.company.office_address ? newVal.company.office_address : null,
        notes: newVal.about,
        exp_date: newVal.passport_expirity_date && newVal.passport_expirity_date !== '0000-00-00' ? newVal.passport_expirity_date : null,
        nationality_type: newVal.nationality_type ? newVal.nationality_type : null,
      };
      this.data_employee = employeeForm;
      this.image_default = newVal.photo_url;
      this.user_company_id = newVal.user_company_id;
      this.load_first = true;

      if (employeeForm.role.id === Constant.RoleAdmin) {
        employeeForm.role.label = 'Admin';
        this.isAdmin = true;
      }

      this.setDetailEmployee(employeeForm);
    },

    organigram_detail(newVal) {
      const list = [...newVal];
      this.data_positions = [];
      list.forEach((val) => {
        this.data_positions.push({
          id: val.organigram.id,
          position_name: val.organigram.name,
          position_code: val.organigram.code,
          description: val.organigram.description,
          divisions: val.organigram.divisions || [],
          fulldata: val.organigram,
        });
      });
    },

    // eslint-disable-next-line
    'data_position.position': function (newData) {
      this.data_position.parent_position = '';
      this.data_position.division = [];
      if (newData.organigram_head_id !== 0) {
        this.data_position.parent_position = newData.organigram_head_name;
      }

      if (newData.divisions.length > 0) {
        const dataDivisions = newData.divisions;
        dataDivisions.forEach((val, index) => {
          dataDivisions[index].label = val.name;
        });
        this.data_position.division = dataDivisions;
      }
    },

    // eslint-disable-next-line
    'data_employee.email': function(val) {
      const data = val.replace(/\s/g, '');
      this.data_employee.email = data;
    },

    // eslint-disable-next-line
    'data_employee.country.id': function(val) {
      if (val !== null && typeof val !== 'undefined') {
        const req = {
          country_id: val,
        };
        this.getListProvince(req)
          .then(() => {
            this.home_province_options = [];
            this.home_province_options.push(...this.list_province);
          });
      }
    },

    // eslint-disable-next-line
    'data_employee.province': function(val) {
      if (val !== null && typeof val !== 'undefined') {
        const req = {
          province_id: val,
        };
        this.getListCity(req)
          .then(() => {
            this.home_city_options = [];
            this.home_city_options.push(...this.list_city);
          });
      }
    },

    // eslint-disable-next-line
    'data_employee.office_country': function(val) {
      if (val !== null && typeof val !== 'undefined') {
        const req = {
          country_id: val,
        };
        this.getListProvince(req)
          .then(() => {
            this.office_province_options = [];
            this.office_province_options.push(...this.list_province);
          });
      }
    },

    // eslint-disable-next-line
    'data_employee.date_of_birth': function(val) {
      if (val !== null) {
        const now = new Date();
        let birthday;
        if (typeof val === 'string') {
          birthday = new Date(val);
        } else if (typeof val === 'object') {
          birthday = val;
        }
        const age = now - birthday;
        // eslint-disable-next-line
        this.data_employee.age = parseInt(age / 31556952000);
      }
    },

    // eslint-disable-next-line
    'data_employee.join_date': function(val) {
      if (val) {
        this.disabled_end_dates.ranges = [
          {
            from: new Date(1970, 0, 1),
            to: new Date(val),
          },
        ];
        this.disabled_contract_end_date.ranges = [
          {
            from: new Date(1970, 0, 1),
            to: new Date(val),
          },
        ];
        this.disabled_contract_start_date.ranges = [
          {
            from: new Date(1970, 0, 1),
            to: new Date(val),
          },
        ];
      }
      if (val && this.data_employee.end_date) {
        this.disabled_contract_start_date.ranges = [
          {
            from: new Date(1970, 0, 1),
            to: new Date(val),
          },
          {
            from: new Date(this.data_employee.end_date),
            to: new Date(9999, 11, 31),
          },
        ];
        this.disabled_contract_end_date.ranges = [
          {
            from: new Date(1970, 0, 1),
            to: new Date(val),
          },
          {
            from: new Date(this.data_employee.end_date),
            to: new Date(9999, 11, 31),
          },
        ];
      }
    },

    // eslint-disable-next-line
    'data_employee.end_date': function(val) {
      if (val) {
        this.disabled_start_dates.ranges = [
          {
            from: new Date(val),
            to: new Date(9999, 11, 31),
          },
        ];
        this.disabled_contract_start_date.ranges = [
          {
            from: new Date(val),
            to: new Date(9999, 11, 31),
          },
        ];
        this.disabled_contract_end_date.ranges = [
          {
            from: new Date(val),
            to: new Date(9999, 11, 31),
          },
        ];
      }
      if (val && this.data_employee.join_date) {
        this.disabled_contract_start_date.ranges = [
          {
            from: new Date(1970, 0, 1),
            to: new Date(this.data_employee.join_date),
          },
          {
            from: new Date(val),
            to: new Date(9999, 11, 31),
          },
        ];
        this.disabled_contract_end_date.ranges = [
          {
            from: new Date(1970, 0, 1),
            to: new Date(this.data_employee.join_date),
          },
          {
            from: new Date(val),
            to: new Date(9999, 11, 31),
          },
        ];
      }
    },

    // eslint-disable-next-line
    'data_employee.contract_start_date': function(val) {
      if (val) {
        this.disabled_contract_end_date.ranges = [
          {
            from: new Date(1970, 0, 1),
            to: new Date(val),
          },
        ];
      }
    },

    // eslint-disable-next-line
    'data_employee.contract_end_date': function(val) {
      if (val) {
        this.disabled_contract_start_date.ranges = [
          {
            from: new Date(val),
            to: new Date(9999, 11, 31),
          },
        ];
      }
    },
  },
  created() {
    this.load_first = false;
    // const reqData = {
    //   pagination: {
    //     limit: 0,
    //     page: 1,
    //     column: '',
    //     ascending: true,
    //     query: '',
    //     query_type: 'name',
    //   },
    // };
    // this.getListCompany(reqData);
    // this.getListCountry();
    // this.getListBankAll(reqData);
    // this.getListTeams(reqData);
    this.modeUpdate();
  },
  methods: {
    ...mapActions('jStoreEmployee', ['detailEmployee', 'updateOrganigram']),
    ...mapMutations('jStoreEmployee', ['setDetailEmployee']),

    modeUpdate() {
      const employeeId = {
        id: Number(this.$route.params.id),
      };

      this.detailEmployee(employeeId);
    },

    resetProvince() {
      this.data_employee.province = null;
    },
    resetCity() {
      this.data_employee.city = null;
    },
    resetOfficeProvince() {
      this.data_employee.office_province = null;
    },
    getCity(val) {
      if (val !== null && typeof val !== 'undefined') {
        this.show_office_city = true;
        const req = {
          province_id: val,
        };
        this.getListCity(req)
          .then(() => {
            this.office_city_options = [];
            this.office_city_options.push(...this.list_city);
          });
      } else {
        this.show_office_city = false;
        this.data_employee.office_city = null;
      }
    },
    getDataImage(data) {
      this.data_employee.photo = data;
    },
    save() {
      this.$v.data_employee.$touch();
      if (!this.$v.data_employee.$error) {
        this.$emit('data', this.data_employee);
      } else {
        this.$emit('data', null);
      }
    },
    onShowModal() {
      this.labelAddPosition = 'Add Position';
      this.labelBtnPosition = 'Submit';
      this.$refs.addPosition.show();
      this.$v.data_position.$reset();
    },
    onClose() {
      this.$refs.addPosition.hide();
      this.data_position.position = null;
      this.data_position.parent_position = null;
      this.data_position.division = null;
    },
    onSubmit() {
      this.$refs.addPosition.hide();

      const dataDivisions = [];
      this.data_position.division.forEach((val) => {
        dataDivisions.push(val.id);
      });

      const data = {
        id: this.data_position.position.id,
        name: this.data_position.position.name,
        code: this.data_position.position.code,
        description: this.data_position.position.description,
        user_company_id: this.user_company_id,
        organigram_head_id: this.data_position.position.organigram_head_id,
        organigram_head_name: this.data_position.position.organigram_head_name,
        divisions: dataDivisions,
      };
      const generateData = {
        payload: data,
        user_company_id: this.user_company_id,
      };
      this.updateOrganigram(generateData);

      if (this.labelAddPosition === 'Update Position') {
        const dataDeleteDivisions = [];
        this.data_positions[this.index_positions].divisions.forEach((val) => {
          dataDeleteDivisions.push(val.id);
        });
        const dataDelete = {
          id: this.data_positions[this.index_positions].id,
          name: this.data_positions[this.index_positions].position_name,
          code: this.data_positions[this.index_positions].position_code,
          description: this.data_positions[this.index_positions].description,
          user_company_id: 0,
          organigram_head_id: this.data_positions[this.index_positions].fulldata.organigram_head_id,
          organigram_head_name: this.data_positions[this.index_positions].fulldata.organigram_head_name,
          divisions: dataDeleteDivisions,
        };
        const generateDataDelete = {
          payload: dataDelete,
          user_company_id: this.user_company_id,
        };
        this.updateOrganigram(generateDataDelete);
      }

      this.data_position.position = null;
      this.data_position.parent_position = null;
      this.data_position.division = null;
    },
    onClickEdit(index) {
      this.index_positions = index;
      this.labelAddPosition = 'Update Position';
      this.labelBtnPosition = 'Update';
      this.$refs.addPosition.show();
      this.data_positions[index].fulldata.label = this.data_positions[index].fulldata.name;
      this.data_position.position = this.data_positions[index].fulldata;
    },
    onClickDelete(index) {
      const dataDivisions = [];
      this.data_positions[index].divisions.forEach((val) => {
        dataDivisions.push(val.id);
      });

      const data = {
        id: this.data_positions[index].id,
        name: this.data_positions[index].position_name,
        code: this.data_positions[index].position_code,
        description: this.data_positions[index].description,
        user_company_id: 0,
        organigram_head_id: this.data_positions[index].fulldata.organigram_head_id,
        organigram_head_name: this.data_positions[index].fulldata.organigram_head_name,
        divisions: dataDivisions,
      };
      const generateData = {
        payload: data,
        user_company_id: this.user_company_id,
      };
      this.updateOrganigram(generateData);
    },
    loadOptionsBank({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const reqData = {
          pagination: {
            limit: 50,
            page: 1,
            column: '',
            ascending: true,
            query: searchQuery,
            query_type: 'name',
          },
        };
        this.$store.dispatch('jStoreEmployee/getListBank', { reqData, callback });
      }
    },
    loadOptionsPosition({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const reqData = {
          pagination: {
            limit: 50,
            page: 1,
            column: '',
            ascending: true,
            query: searchQuery,
            query_type: 'position',
          },
        };
        this.$store.dispatch('jStoreEmployee/getListPosition', { reqData, callback, label: (this.filter ? this.filter : 'name') });
      }
    },
    loadOptionsPositionParent({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const reqData = {
          pagination: {
            limit: 50,
            page: 1,
            column: '',
            ascending: true,
            query: searchQuery,
            query_type: 'position',
          },
        };
        this.$store.dispatch('jStoreEmployee/getListPosition', { reqData, callback, label: (this.filter ? this.filter : 'name') });
      }
    },
    loadOptionsDivision({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const reqData = {
          pagination: {
            limit: 50,
            page: 1,
            column: '',
            ascending: true,
            query: searchQuery,
          },
        };
        this.$store.dispatch('jStoreEmployee/getListDivision', { reqData, callback });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/user-employee/detail/jEmployeeFormUpdate.vue